/**
 * A HOC that uses @loadable/component to load components with code-splitting support
 *
 * Copyright (c) 2019 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import React from 'react'
import Loadable from '@loadable/component'
import pMinDelay from 'p-min-delay'
import LoadingScreen from '../LoadingScreen'

export default (loadableComponent) => {
  return Loadable(() => pMinDelay(loadableComponent(), 200), {
    fallback: (<LoadingScreen />)
  })
}
